import { Ticket, PriceRule } from './types'
import { differenceInMinutes, getHours } from 'date-fns'

export function calculatePrice(ticket: Ticket, rules: PriceRule[]): number {
  if (!ticket.checkInAt) return 0

  if (ticket.isMonthly) return 0

  const rule = rules.find((r) => r.type === ticket.type)
  if (!rule) return 0

  const now = ticket.checkOutAt || new Date()
  const diffMins = differenceInMinutes(now, ticket.checkInAt)

  // Grace period check
  if (diffMins <= rule.graceMinutes) {
    return 0
  }

  let total = 0

  // First hour charge
  if (diffMins <= 60) {
    total = rule.firstHour
  } else {
    // Additional hours
    const additionalMins = diffMins - 60
    let additionalHours = additionalMins / 60

    switch (rule.roundingMode) {
      case 'floor':
        additionalHours = Math.floor(additionalHours)
        break
      case 'round':
        additionalHours = Math.round(additionalHours)
        break
      case 'none':
        break
      case 'ceil':
      default:
        additionalHours = Math.ceil(additionalHours)
        break
    }

    total = rule.firstHour + additionalHours * rule.additionalHour
  }

  // Peak Hours check
  if (rule.peakMultiplier && rule.peakStartHour && rule.peakEndHour) {
    const checkInHour = getHours(ticket.checkInAt)
    const peakStart = parseInt(rule.peakStartHour.split(':')[0])
    const peakEnd = parseInt(rule.peakEndHour.split(':')[0])

    if (peakStart <= peakEnd) {
      if (checkInHour >= peakStart && checkInHour < peakEnd) {
        total *= rule.peakMultiplier
      }
    } else {
      if (checkInHour >= peakStart || checkInHour < peakEnd) {
        total *= rule.peakMultiplier
      }
    }
  }

  // Daily cap check
  if (rule.dailyCap > 0 && total > rule.dailyCap) {
    total = rule.dailyCap
  }

  return total
}

export function formatCurrency(value: number): string {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value)
}

export function formatPlate(value: string): string {
  const cleaned = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
  if (cleaned.length <= 3) return cleaned
  return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 7)}`
}
